import { defineComponent as _defineComponent } from 'vue';
import { useSettingsStore } from '@/store/modules/settings';
import { translate } from '@/i18n';

import { inject } from 'vue';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'VabThemeSetting',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const $pub = inject('$pub');
    //const $baseMessage: any = inject('$baseMessage')
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const handleOpenTheme = () => {
      $pub('theme');
    };
    const randomTheme = () => {
      $pub('random-theme');
    };
    // const getCode = () => {
    //     if (process.env.NODE_ENV === 'development') $pub('get-code')
    //     else
    //         ElMessageBox.prompt(
    //             '请输入密码(密码在购买时获得，跳转后需登录购买时绑定的github账号)',
    //             '温馨提示',
    //             {
    //                 confirmButtonText: '确定',
    //                 cancelButtonText: '取消',
    //             }
    //         )
    //             .then(({ value }) => {
    //                 if (value !== 'vabp') {
    //                     $baseMessage(
    //                         '密码不正确！',
    //                         'error',
    //                         'vab-hey-message-error'
    //                     )
    //                     return
    //                 }
    //                 $pub('get-code')
    //             })
    //             .catch(() => {})
    // }
    const removeLocalStorage = () => {
      localStorage.clear();
      location.reload();
    };
    const __returned__ = {
      $pub,
      settingsStore,
      theme,
      handleOpenTheme,
      randomTheme,
      removeLocalStorage,
      get translate() {
        return translate;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});